import axios from 'axios'
import { API_URL } from '../../../../setup/config/env'

export function getbookingSettings() {
    return dispatch => {
    return axios.get(API_URL+"/api/tableBookingConfig/")
}
}

export const list = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/tableBooking/`);
        return response;
    } catch (error) {
        console.error("Error fetching bookings:", error);
        throw error;
    }
};

export function getAllbookingsbyDate(date) {
    return dispatch => {
    return axios.post(API_URL+"/api/tableBooking/bookings/",{ date })
}
}

export function getSlots(day) {
    return dispatch => {
    return axios.post(API_URL+"/api/tableBooking/slots",{ day })
}
}

export function getAllbookings() {
    return dipatch => {
        return axios.get(API_URL+"/api/tableBooking/all")
    }
};

export function getBookingDetails(bookingId) {
        return axios.post(API_URL+"/api/tableBooking/",{ "_id": bookingId })
};

export function cancelBooking(bookingId, reason) {
      return axios.post(API_URL+"/api/tableBooking/cancel-booking", { "_id": bookingId, reason })
}

export function downloadBooking() {
    return dispatch => {
    return axios.get(API_URL+"/api/tableBooking/download")
}
}